<div class="container-fluid h-100 d-flex flex-column pb-2 px-0 position-relative"
  style="max-width: 900px;"
  (dragover)="handleDragOver($event)"
  (dragenter)="handleDragEnter($event)"
  (dragleave)="handleDragLeave($event)"
  (drop)="handleDrop($event)">
  @if (imageUploadEnabled() && isDraggingFiles()) {
    <div class="drop-overlay">
      <div class="drop-box">
        <div>Drop your files here</div>
      </div>
    </div>
  }
  <!-- Mode Tabs: Healthcare / General -->
  <div class="mode-tabs-bar">
    <div class="mode-track">
      <button type="button"
        class="mode-btn"
        [class.mode-btn-active]="chatMode() === 'healthcare'"
        (click)="setChatMode('healthcare')">
        <i class="bi bi-heart-pulse"></i>Healthcare
      </button>
      <button type="button"
        class="mode-btn"
        [class.mode-btn-active]="chatMode() === 'general'"
        (click)="setChatMode('general')">
        <i class="bi bi-chat-text"></i>General
      </button>
    </div>
  </div>

  <div #messagesContainer class="flex-grow-1 overflow-y-auto chat-scroll px-3" style="min-height: 0; padding-top: 18px;">

    <!-- Empty-state hero: shown until the first real question is sent -->
    @if (isWelcomeOnly()) {
      <div class="hero">
        <div class="hero-mark">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2.5c.4 0 .74.27.84.66l.9 3.5a4.6 4.6 0 003.3 3.3l3.5.9a.87.87 0 010 1.68l-3.5.9a4.6 4.6 0 00-3.3 3.3l-.9 3.5a.87.87 0 01-1.68 0l-.9-3.5a4.6 4.6 0 00-3.3-3.3l-3.5-.9a.87.87 0 010-1.68l3.5-.9a4.6 4.6 0 003.3-3.3l.9-3.5c.1-.39.44-.66.84-.66z"/>
          </svg>
        </div>
        <h2 class="hero-title">{{ chatMode() === 'general' ? 'Ask me anything' : 'Ask Civie-AI' }}</h2>
        <p class="hero-subtitle">
          {{ chatMode() === 'general'
          ? 'Your AI assistant for general knowledge, research, and everyday questions.'
          : 'Healthcare, radiology, and CIVIE product questions - grounded in verified sources.' }}
        </p>
        <div class="hero-cards">
          @if (chatMode() === 'healthcare') {
            <button type="button" class="hero-card" (click)="quickFill('What are the current guidelines for incidental pulmonary nodules?')">
              <i class="bi bi-lungs"></i>
              <span>Guidelines for incidental pulmonary nodules</span>
            </button>
            <button type="button" class="hero-card" (click)="quickFill('What are the BI-RADS categories for mammography?')">
              <i class="bi bi-clipboard2-pulse"></i>
              <span>BI-RADS categories for mammography</span>
            </button>
            <button type="button" class="hero-card" (click)="quickFill('How is suspected deep vein thrombosis usually diagnosed with imaging?')">
              <i class="bi bi-file-medical"></i>
              <span>How is suspected DVT diagnosed with imaging?</span>
            </button>
            <button type="button" class="hero-card" (click)="quickFill('When should a CT scan be preferred over an MRI?')">
              <i class="bi bi-heart-pulse"></i>
              <span>CT vs MRI: when to prefer which</span>
            </button>
          }
          @if (chatMode() === 'general') {
            <button type="button" class="hero-card" (click)="quickFill('What is CIVIE and what does it offer?')">
              <i class="bi bi-hospital"></i>
              <span>What is CIVIE and what does it offer?</span>
            </button>
            <button type="button" class="hero-card" (click)="quickFill('How does health insurance prior authorization work?')">
              <i class="bi bi-file-medical"></i>
              <span>How does prior authorization work?</span>
            </button>
            <button type="button" class="hero-card" (click)="quickFill('What is the difference between an HMO and a PPO insurance plan?')">
              <i class="bi bi-shield-check"></i>
              <span>HMO vs. PPO: what's the difference?</span>
            </button>
            <button type="button" class="hero-card" (click)="quickFill('What are the latest trends in AI for radiology?')">
              <i class="bi bi-activity"></i>
              <span>Latest trends in AI for radiology</span>
            </button>
          }
        </div>
      </div>
    }

    @if (!isWelcomeOnly()) {
      @for (m of messages(); track m; let i = $index) {
        <div class="mb-3 d-flex align-items-start"
          [class.d-none]="i === 0 && m.role === 'assistant'"
          [ngClass]="m.role === 'user' ? 'justify-content-end' : 'justify-content-start'">
          @if (m.role !== 'user') {
            <div class="msg-avatar" [class.msg-avatar-hidden]="!isRunStart(i)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 2.5c.4 0 .74.27.84.66l.9 3.5a4.6 4.6 0 003.3 3.3l3.5.9a.87.87 0 010 1.68l-3.5.9a4.6 4.6 0 00-3.3 3.3l-.9 3.5a.87.87 0 01-1.68 0l-.9-3.5a4.6 4.6 0 00-3.3-3.3l-3.5-.9a.87.87 0 010-1.68l3.5-.9a4.6 4.6 0 003.3-3.3l.9-3.5c.1-.39.44-.66.84-.66z"/>
              </svg>
            </div>
          }
          <div class="position-relative bubble"
           [ngClass]="{
             'bubble-user': m.role === 'user',
             'bubble-assistant': m.role !== 'user',
             'message-faded': !isMessageInContext(i) && i !== 0
           }"
            [style.opacity]="isMessageInContext(i) || i === 0 ? 1 : 0.4">
            <button type="button"
              class="position-absolute copy-btn m-0"
              (click)="copyMessage(m.content, i)"
              aria-label="Copy message">
              @if (copiedIndex() !== i) {
                <i class=""><svg style="width: 17px;height: 17px;" class="" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg></i>
              }
              @if (copiedIndex() === i) {
                <i class=""><svg style="width: 17px;height: 17px;" class="" fill="#22c55e" viewBox="0 0 20 20"><path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill-rule="evenodd" clip-rule="evenodd"></path></svg></i>
              }
            </button>
            @if (m.role === 'assistant') {
              @if ((m.content || '').trim().length) {
                <div class="assistant-content" [innerHTML]="renderMarkdown(m.content, m.citationSources)"></div>
                <!-- AI Follow-up Suggestions - show after last assistant message -->
                @if (i === messages().length - 1 && !isSending() && !error()) {
                  <!-- Loading state -->
                  @if (isLoadingFollowUp()) {
                    <div class="follow-up-container">
                      <div class="follow-up-loading">
                        <span class="spinner-border text-primary" role="status"></span>
                        <span>Generating follow-up suggestions...</span>
                      </div>
                    </div>
                  }
                  <!-- Follow-up questions -->
                  @if (!isLoadingFollowUp() && followUpQuestions().length > 0) {
                    <div class="follow-up-container">
                      <div class="follow-up-label">
                        <i class="bi bi-lightbulb-fill"></i>
                        <span>Continue the conversation</span>
                      </div>
                      <div class="follow-up-questions">
                        @for (question of followUpQuestions(); track question; let idx = $index) {
                          <button
                            type="button"
                            class="follow-up-btn"
                            (click)="useFollowUpQuestion(question)">
                            <span class="question-icon">{{ idx + 1 }}</span>
                            <span class="question-text">{{ question }}</span>
                          </button>
                        }
                      </div>
                    </div>
                  }
                }
                <!-- Regenerate button after last assistant message -->
                @if (i === messages().length - 1 && canRegenerate() && !isSending() && !error()) {
                  <div
                    class="d-flex justify-content-start mt-2">
                    <button type="button"
                      class="btn btn-sm btn-outline-secondary rounded-pill px-3 py-1"
                      style="font-size: 12px;"
                      (click)="regenerateResponse()">
                      <i class="bi bi-arrow-clockwise me-1"></i>Regenerate
                    </button>
                  </div>
                }
              } @else {
                @if (showProgress() && progressSteps().length > 0 && getLastProgressStep(); as currentStep) {
                  <div class="status-pill">
                    <span class="status-pill-spinner"></span>
                    <span class="status-pill-text">
                      <span class="status-pill-label">{{ getStepLabel(currentStep.step) }}</span>
                      @if (currentStep.message) {
                        <span class="status-pill-message">{{ currentStep.message }}</span>
                      }
                    </span>
                  </div>
                }
                @if (!(showProgress() && progressSteps().length > 0)) {
                  <div class="status-pill">
                    <span class="status-pill-spinner"></span>
                    <span class="status-pill-text"><span class="status-pill-label">Thinking</span></span>
                  </div>
                }
              }
            } @else {
              @if (m.error) {
                <div class="d-flex align-items-center gap-1 mb-1" style="color:#dc3545;">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                    <path d="M12 2a1 1 0 01.894.553l9 18A1 1 0 0121 22H3a1 1 0 01-.894-1.447l9-18A1 1 0 0112 2zm0 5a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1zm0 10a1.25 1.25 0 100 2.5A1.25 1.25 0 0012 17z"></path>
                  </svg>
                  <span class="small">Failed to send</span>
                </div>
              }
              @if (m.attachments?.length) {
                <div class="attachments">
                  @for (att of m.attachments; track att) {
                    <a [href]="att.src" target="_blank" rel="noopener" class="thumb-link">
                      <img class="thumb" [src]="att.src" alt="attachment" />
                      @if (att.name) {
                        <div style="position:absolute; left:0; right:0; bottom:0; background: rgba(0,0,0,0.6); color:#fff; font-size:11px; padding:2px 4px; border-bottom-left-radius:6px; border-bottom-right-radius:6px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                          {{ att.name }}
                        </div>
                      }
                    </a>
                  }
                </div>
              }
              <div class="text-secondary small w-100 opacity-100 text-white-50 mt-1" style="flex-basis: 100%;font-size: 12px;">{{ formatAttachmentSummary(m.attachments) }}</div>
              <div class="text-wrap text-white" style="white-space: pre-wrap;">{{ m.content }}</div>
              <!-- Retry button after user message on error -->
              @if (m.error && i === messages().length - 1 && !isSending()) {
                <div
                  class="d-flex justify-content-end mt-2">
                  <button type="button"
                    class="btn btn-sm btn-outline-light rounded-pill px-3 py-1"
                    style="font-size: 12px;"
                    (click)="retryLastRequest()">
                    <i class="bi bi-arrow-repeat me-1"></i>Retry
                  </button>
                </div>
              }
            }
            @if (isRunEnd(i)) {
              <div class="timestamp mt-1 opacity-100" [ngClass]="m.role === 'user' ? 'text-white-50' : 'text-secondary'">
                {{ m.timestamp | date:'hh:mm a' }}
              </div>
            }
          </div>
        </div>
      }
    }
  </div>

  <!-- Input Area -->
  <div class="px-3 pt-2 pb-1">
    <form (submit)="onSend($event)" class="input-container">
      <!-- Attached Images Preview -->
      @if (imageUploadEnabled() && (attachedImages.length || imageUrls.length)) {
        <div class="input-attachments">
          @for (img of attachedImages; track img; let i = $index) {
            <div class="position-relative border rounded p-1">
              <img [src]="img.dataUrl" alt="preview" style="height:40px; width:auto;" />
              <button type="button" class="btn btn-sm position-absolute" style="top:-6px; right:-5px; width: 14px; height: 14px; background-color: #FF3363; border-radius: 50%; padding: 0; display: flex; align-items: center; justify-content: center;" (click)="removeImage(i)" aria-label="Remove image">
                <i class="bi bi-x text-white" style="font-size: 10px;"></i>
              </button>
            </div>
          }
        </div>
      }

      <!-- Main Input Row: [+] [textarea] [send] -->
      <div class="input-row">
        @if (imageUploadEnabled()) {
          <input id="chatFileInput" type="file" accept="image/*" multiple (change)="onFilesSelected($event)" class="d-none" [disabled]="!canAddMoreImages()" />
          <label for="chatFileInput" class="input-icon-btn" [class.disabled]="!canAddMoreImages()">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="18" height="18">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 4v16m8-8H4"></path>
            </svg>
          </label>
        }

        <textarea [(ngModel)]="draft" name="draft" rows="1" class="input-textarea" [placeholder]="placeholderText()" (keydown.enter)="onEnterKey($event)"></textarea>

        <button type="submit" [disabled]="!sendEnabled()" class="input-send-btn" [class.active]="sendEnabled()">
          @if (!isSending()) {
            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
              <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"></path>
            </svg>
          } @else {
            <span class="spinner-border spinner-border-sm" role="status"></span>
          }
        </button>
      </div>

      <!-- Footer: Suggestions & Settings buttons - suggestions are general-mode only -->
      <div class="input-footer">
        @if (chatMode() === 'general') {
          <button type="button" class="input-footer-btn" [class.active]="!isSuggestionsCollapsed()" (click)="toggleSuggestions()">
            <i class="bi" [ngClass]="isSuggestionsCollapsed() ? 'bi-lightbulb' : 'bi-lightbulb-fill'"></i>
            <span>Suggestions</span>
          </button>
        }
        <button type="button" class="input-footer-btn" [class.active]="showAdvancedSettings()" (click)="toggleAdvancedSettings()">
          <i class="bi bi-gear"></i>
          <span>Settings</span>
        </button>
      </div>
    </form>

    <!-- Suggestions (outside container) - general mode only; the hero cards already
    cover this on the empty screen, so this only shows once a conversation is
    underway. -->
    @if (!isWelcomeOnly() && chatMode() === 'general') {
      <div class="suggestions-wrapper mt-2" [ngClass]="{'collapsed': isSuggestionsCollapsed()}">
        <div class="d-flex flex-wrap gap-1 justify-content-center">
          @if (chatMode() === 'general') {
            <button type="button" (click)="quickFill('What is CIVIE and what does it offer?')" class="btn btn-outline-secondary rounded-pill btn-sm action-btn">About CIVIE</button>
            <button type="button" (click)="quickFill('How does health insurance prior authorization work?')" class="btn btn-outline-secondary rounded-pill btn-sm action-btn">Prior Authorization</button>
            <button type="button" (click)="quickFill('What is the difference between an HMO and a PPO insurance plan?')" class="btn btn-outline-secondary rounded-pill btn-sm action-btn">HMO vs PPO</button>
          }
        </div>
      </div>
    }

    <!-- Advanced Settings Panel -->
    @if (showAdvancedSettings()) {
      <div class="settings-panel">
        <div class="settings-row">
          <label class="settings-label"><i class="bi bi-chat-dots"></i>Context</label>
          <input type="range" class="form-range flex-grow-1" [min]="4" [max]="getMaxAllowedTurns()" [value]="maxTurns()" (input)="updateMaxTurns($any($event.target).valueAsNumber)" />
          <span class="settings-badge">{{ maxTurns() }}</span>
        </div>
        @if (chatMode() === 'healthcare') {
          <div class="settings-row settings-row-divided">
            <label class="settings-label"><i class="bi bi-globe"></i>Verified sources only</label>
            <div class="form-check form-switch mb-0 ms-auto">
              <input class="form-check-input" type="checkbox" [checked]="restrictDomains()" (change)="toggleRestrictDomains()">
            </div>
          </div>
        }
      </div>
    }

    @if (error()) {
      <div class="alert alert-danger py-1 px-2 mt-2 small">
        <i class="bi bi-exclamation-triangle-fill me-1"></i>{{ error() }}
      </div>
    }

    @if (chatMode() === 'healthcare') {
      <div class="text-muted text-center" style="font-size: 10.5px; margin-top: 6px; opacity: 0.75;">
        <i class="bi bi-info-circle me-1"></i>AI responses may be inaccurate. Verify with healthcare professionals.
      </div>
    }
  </div>
</div>
